goog.module('yext.developerapps.salesforcereviews.ManagedPackage');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const routes = goog.require('yext.developerapps.routes');

/**
 * @constructor
 */
const ManagedPackage = function() {
  this.$ctxt = $('.js-package-install');
  this.init();
};

ManagedPackage.prototype.init = function() {
  this.hideButtons();
};

ManagedPackage.prototype.hideButtons = function() {
  var installBtns = this.$ctxt.find('.js-initial-buttons');
  var continueBtn = this.$ctxt.find('.js-post-install-button');
  this.$ctxt.find('.js-install').on('click', function() {
    installBtns.css('display', 'none');
    continueBtn.css('display', 'block');
  });
};

goog.exportSymbol('yext.developerapps.salesforcereviews.ManagedPackage', ManagedPackage);

exports = ManagedPackage;
